module.exports = __webpack_public_path__ + "img/9.1.7ae2ef70.jpg";